import { render } from "./AcademyImages.vue?vue&type=template&id=6fc4cf2e"
import script from "./AcademyImages.vue?vue&type=script&lang=js"
export * from "./AcademyImages.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__